/**
 * Pine keeps only the newest N lines / boxes / labels (50 unless the script's
 * strategy()/indicator() call sets max_*_count). Indexed by objKind.
 */
export function pineDrawingLimits(source: string | null | undefined): number[] {
  const read = (name: string) => {
    const m = new RegExp(`\\b${name}\\s*=\\s*(\\d+)`).exec(source || "");
    const n = m ? Number(m[1]) : NaN;
    return Number.isFinite(n) && n > 0 ? Math.min(n, 500) : 50;
  };
  return [read("max_lines_count"), read("max_boxes_count"), read("max_labels_count")];
}
